import { RegisterOptions } from 'react-hook-form';
import { REGEX_VALIDATORS, translations } from '@gbm/onboarding-sdk-utils';

export const pepValidations: RegisterOptions = {
  pattern: {
    value: REGEX_VALIDATORS.pep,
    message: translations.inputs.pepInvalid,
  },
};
